import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-113" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto w-full max-w-2xl" data-id="element-114" data-mp="223y639n82bl6">
        <div className="rounded-3xl border border-gold/50 bg-white p-6 text-center sm:p-9" data-id="element-115" data-mp="222n0r5e4ovry">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold-pale" data-id="element-116" data-mp="1x4v27sizabes">
            <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-117" data-mp="19f0mn379y8qu" />
          </span>
          <h2 className="mt-4 font-display text-2xl font-bold leading-tight text-navy sm:text-3xl" data-id="element-118" data-mp="14hhaq9y1u822">
            Garantía de satisfacción de 7 días
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-navy/70 sm:text-base" data-id="element-119" data-mp="1edk8l3lvbkj7">
            Revisa el contenido. Explora los algoritmos. Utiliza las herramientas. Si durante los
            primeros 7 días consideras que la Ruta Clínica no te ayuda a decidir con más claridad y
            seguridad, simplemente escríbenos.
          </p>
          <p className="mt-3 font-display text-xl font-bold text-navy sm:text-2xl" data-id="element-120" data-mp="oxfaqaxb4rt3">
            Te devolvemos el 100% de tu dinero.
          </p>
          <p className="mt-2 text-sm text-navy/55" data-id="element-121" data-mp="yot749typbi0">
            Sin formularios complicados. Sin explicaciones. Sin riesgos.
          </p>
        </div>

        <div className="mt-9" data-id="element-122" data-mp="12t0uo3ooolen">
          <CTAButton label="Quiero probarlo sin riesgo" note="7 días de garantía total" data-id="element-123" data-mp="60xb77c7vnma" />
        </div>
      </div>
    </section>;
}